declare var require: any;

export enum Platform {
  MOBILE = 'mobile',
  WEB = 'web'
};

export const environment = {
  debugMode: false,
  autoCompleteDelay: 600,
  VERSION: require('../../package.json').version,
  THEME: require('../../package.json').name,
  timeoutDefault: 30000,
  timeoutGetStatus: 10000,
  timeoutUploads: 600000,
  timeoutLicense: 60000,
  timeoutDownloads: 30000,
  timeoutBackup: 600000,
  timeoutFNMT: 60000,
  timeoutFP: 60000,
  timeoutSign: 300000,
  isBasicVersion: true,
  protectedResourceMap: 'https://graph.microsoft.com/v1.0/*',
  scopes: [
    'email',
    'Files.Read',
    'Files.Read.All',
    'Files.ReadWrite',
    'Files.ReadWrite.All',
    'offline_access',
    'openid',
    'profile',
    'Sites.Read.All',
    'Sites.ReadWrite.All',
    'User.Read'
  ]
};
